import { UserRole } from "contexts/opus/context"
import { CompanyType, ICompany, Nullable } from "."

export type UserStatus = "Disabled" | "Active" | "Locked" | "Stub" | "Deleted"

export enum EUserGroups {
  Insurer = "Insurer",
  Distributor = "Distributor",
  InsurerAdministrator = "InsurerAdministrator"
}

export enum BrokerRoles {
  BrokerAdministrator = "Broker Administrator",
  AccountManager = "Account Manager",
  User = "User"
}

export interface IUserCompany {
  id: string
  referenceID?: string
  name: Nullable<string>
  companyType: CompanyType
  brokerCanBindBusiness: boolean
  status: string
}

export interface IUserAccountInfo {
  email: Nullable<string>
  externalID: Nullable<string>
  groupID: Nullable<string>
  groupType?: EUserGroups
  id: string
  username: Nullable<string>
  /** the branch (office) the current session is working in */
  company: Nullable<IUserCompany>
  /** all the branches (offices) the user belongs to */
  branches?: IUserCompany[]
}

export interface IUserBranch {
  company: IUserCompany
  /** the branch the user works in when they haven't selected one */
  isDefault: boolean
  /** the number of active clients the user owns in the branch - they can't be removed from it while they own clients */
  ownedClientCount: number
}

export interface IInviteUserRequestBody {
  companyName: string
  companyId?: string
  firstName: string
  lastName: string
  phoneNumber: string
  userRoles: string[]
  username: string
}

export interface IUpdateUserRequestBody {
  firstName: string
  lastName: string
  phoneNumber: string
  userRoles: string[]
}

export interface IOpusUser {
  adminFlags: number
  authID: Nullable<string>
  companyID: Nullable<string>
  companyName: Nullable<string>
  emailVerified: boolean
  externalID: Nullable<string>
  firstName: Nullable<string>
  fullName: Nullable<string>
  groups: unknown
  id: string
  lastLogin: Nullable<string>
  lastName: Nullable<string>
  organizationID: number
  status: UserStatus
  username: Nullable<string>
  roles: UserRole[]
  company: ICompany
  /** the user's branches (offices) the current user can read - only returned for the account manager list */
  branches?: IUserCompany[]
}

export interface IEditEmailRequestBody {
  email: string
  policyId: string
}

export interface IEditEmailParams {
  ownerId: string
  policyId: string
  emailValue: string
}

export interface IChangeEmailExistingAccountCheckResult {
  hasExistingAccount: boolean
  referenceIDs: string[]
}

export interface IBlacklistPhoneNumberParams {
  phoneNumber: string
}
